import * as React from "react";
const SvgFiRrFrenchFries = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-french-fries_svg__a)">
      <path
        fill="#062147"
        d="M23.3 12.078a3 3 0 0 0-1.246-.869l.778-2.239a3.016 3.016 0 0 0-3.146-3.951l.27-1.519a3.002 3.002 0 0 0-5.912-1.041l-.061.307a2.986 2.986 0 0 0-3.967 0l-.056-.279a3.001 3.001 0 1 0-5.916 1.018l.267 1.514a3.017 3.017 0 0 0-3.144 3.957l.776 2.233a2.98 2.98 0 0 0-1.894 3.327l.974 5.357A5 5 0 0 0 5.942 24h12.116a5 5 0 0 0 4.919-4.105l.974-5.356a2.99 2.99 0 0 0-.651-2.461m-2.984-5.023a1 1 0 0 1 .627 1.265l-.93 2.68H18.63l.654-3.7a1 1 0 0 1 1.032-.245m-3.15-5.045a1 1 0 0 1 .82 1.15L16.6 11H15V7.908l1.01-5.081a1 1 0 0 1 1.157-.817M11 5a1 1 0 0 1 2 0v6h-2zM6.833 2.01a1.01 1.01 0 0 1 1.16.842L9 7.908V11H7.4L6.015 3.165a1 1 0 0 1 .818-1.155m-3.15 5.045a1 1 0 0 1 1.033.245L5.37 11H3.987l-.928-2.674a1 1 0 0 1 .625-1.271m18.3 7.124-.973 5.355A3 3 0 0 1 18.058 22H5.942a3 3 0 0 1-2.951-2.462l-.974-5.356A1 1 0 0 1 3 13h18a1 1 0 0 1 .984 1.179"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-french-fries_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFrenchFries;
